import React from 'react'
import { Row, Divider, Col, Form, Typography, Button } from 'antd'
import { Link } from 'react-router-dom'
import moment from 'moment'
import Segment from '../../components/Segment'
import API from '../../services/API'

const { Paragraph } = Typography
const INIT = {
    code: '',
    description: '',
    active: true,
}
const SatCodeShowContainer = ({ match }) => {
    const [loading, setloading] = React.useState(false)
    const [data, setData] = React.useState(INIT)

    const getData = () => {
        setloading(true)
        API.get(`/api/sat_code/${match.params.id}`)
            .then(response => {
                setData(response.data)
            })
            .catch(error => {
                console.error('Error en  al obtener el codigo sat', error)
            })
            .finally(() => {
                setloading(false)
            })
    }
    React.useEffect(() => {
        getData()
    }, [])

    return (
        <Segment loading={loading}>
            <Divider>Detalle de codigo sat</Divider>
            <Form style={{ maxWidth: '500px', margin: 'auto' }} className="form-border">
                <Row gutter={24}>
                    <Col lg={12} md={12} sm={24}>
                        <Paragraph strong>Codigo:</Paragraph>
                    </Col>
                    <Col lg={12} md={12} sm={24}>
                        <Paragraph>{data.code}</Paragraph>
                    </Col>
                </Row>

                <Row gutter={24}>
                    <Col lg={12} md={12} sm={24}>
                        <Paragraph strong>Descripición:</Paragraph>
                    </Col>
                    <Col lg={12} md={12} sm={24}>
                        <Paragraph>{data.description}</Paragraph>
                    </Col>
                </Row>

                <Row gutter={24}>
                    <Col lg={12} md={12} sm={24}>
                        <Paragraph strong>Activo:</Paragraph>
                    </Col>
                    <Col lg={12} md={12} sm={24}>
                        <Paragraph>{data.active ? 'Si' : 'No'}</Paragraph>
                    </Col>
                </Row>

                <Row gutter={24}>
                    <Col lg={12} md={12} sm={24}>
                        <Paragraph strong>Creación:</Paragraph>
                    </Col>
                    <Col lg={12} md={12} sm={24}>
                        {data.created_at ? moment(data.created_at).format('DD/MM/YYYY hh:mm A') : ''}
                    </Col>
                </Row>

                <Row gutter={24}>
                    <Col lg={12} md={12} sm={24}>
                        <Paragraph strong>Actualización:</Paragraph>
                    </Col>
                    <Col lg={12} md={12} sm={24}>
                        {data.updated_at ? moment(data.updated_at).format('DD/MM/YYYY hh:mm A') : ''}
                    </Col>
                </Row>
            </Form>
            <Row type="flex" justify="center" style={{ marginTop: '50px' }}>
                <Form.Item>
                    <Link to="/categories" style={{ marginLeft: '5px' }}>
                        <Button  icon="arrow-left">
                            Regresar
                        </Button>
                    </Link>
                </Form.Item>
            </Row>
        </Segment>
    )
}

export default SatCodeShowContainer
